import "./style.css";
import "./styleMobile.css";
import "./styleDesktop.css";
import icon from "./common/images/favicon.ico";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react";

import Home from "./home/pages/Home";

import Workout from "./workout/pages/Workout";

import Subscriptions from "./shop/pages/Subscriptions";

import Register from "./registration/pages/Register";
import Login from "./registration/pages/Login";

import AdminWorkouts from "./admin/pages/AdminWorkouts";
import AdminExercises from "./admin/pages/AdminExercises";
import AdminUsers from "./admin/pages/AdminUsers";

import HomeRouter from "./home/pages/HomeRouter";
import LoadingPlaceholder from "./loading/pages/LoadingPlaceholder";
import AdminLayout from "./admin/components/AdminLayout";
import AdminSubscriptions from "./admin/pages/AdminSubscriptions";
import AccountLayout from "./account/components/AccountLayout";
import Workouts from "./account/pages/Workouts";
import Skills from "./account/pages/Skills";
import Database from "./account/pages/Database";
import AuthProvider from "./auth/hook";
import WorkoutLayout from "./workout/components/WorkoutLayout";
import WorkoutProvider from "./workout/hooks/workoutHook";
import WorkoutCompleted from "./workout/pages/WorkoutCompleted";
import WorkoutDetails from "./workout/pages/WorkoutDetails";
import WorkoutExerciseDetails from "./workout/pages/WorkoutExerciseDetails";
import Plan from "./plan/pages/Plan";
import PlanLayout from "./plan/components/PlanLayout";
import PlanProvider from "./plan/hooks/planHook";
import PlanDetails from "./plan/pages/PlanDetails";
import AdminPlans from "./admin/pages/AdminPlans";
import CheckoutSuccess from "./shop/pages/CheckoutSuccess";
import ShopLayout from "./shop/components/ShopLayout";
import PurchaseSuccess from "./shop/pages/PurchaseSuccess";
import PurchaseFail from "./shop/pages/PurchaseFail";
import AccountWorkoutsLayout from "./account/components/AccountWorkoutsLayout";
import Exercises from "./account/pages/Exercises";
import ExerciseLayout from "./exercise/components/ExerciseLayout";
import Exercise from "./exercise/pages/Exercise";
import ExerciseProvider from "./exercise/hooks/exerciseHook";
import Account from "./account/pages/Account";
import AccountSettings from "./settings/pages/AccountSettings";
import Profile from "./account/pages/Profile";
import CompletedWorkouts from "./account/pages/CompletedWorkouts";
import PurchasedWorkouts from "./shop/pages/PurchasedWorkouts";
import PurchasedSubscriptions from "./shop/pages/PurchasedSubscriptions";
import PrivacyPolicy from "./docs/pages/PrivacyPolicy";
import TermsOfService from "./docs/pages/TermsOfService";
import { PALETTE } from "./common/ThemeConstants";
import Settings from "./settings/pages/settings";

function App() {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.setAttribute("href", icon);
  }, []);

  return (
    <Router>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          backgroundColor: PALETTE.LIGHTGRAY,
        }}
      />
      <div
        className="App"
        style={{
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
          overflowX: "unset",
          overflowY: "unset",
        }}
      >
        <AuthProvider>
          <WorkoutProvider>
            <PlanProvider>
              <ExerciseProvider>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <HomeRouter
                        notLogged={"/home"}
                        logged={"/account/Profile"}
                        loading={<LoadingPlaceholder />}
                      />
                    }
                  />
                  <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                  <Route path="/TermsOfService" element={<TermsOfService />} />
                  <Route path="/home" element={<Home />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/account/" element={<AccountLayout />}>
                    <Route
                      path="/account/Workouts"
                      element={<AccountWorkoutsLayout />}
                    >
                      <Route
                        path="/account/Workouts/Workout"
                        element={<Workouts />}
                      />
                      <Route
                        path="/account/Workouts/Postural"
                        element={<Workouts />}
                      />
                      <Route
                        path="/account/Workouts/Personal"
                        element={<Workouts />}
                      />
                    </Route>
                    <Route path="/account/Profile" element={<Profile />}>
                      <Route
                        path="/account/Profile/Skills"
                        element={<Skills />}
                      />
                      <Route
                        path="/account/Profile/Workouts"
                        element={<CompletedWorkouts />}
                      />
                    </Route>
                    <Route path="/account/Account" element={<Account />} />
                    <Route path="/account/AccountSettings" element={<AccountSettings />} />
                    <Route path="/account/Exercises" element={<Exercises />} />
                    <Route path="/account/Database" element={<Database />} />
                  </Route>
                  <Route
                    path="/account/Account/Workouts"
                    element={<PurchasedWorkouts />}
                  />
                  <Route
                    path="/account/Account/Subscriptions"
                    element={<PurchasedSubscriptions />}
                  />
                  <Route
                    path="/exercise/:idExercise"
                    element={<ExerciseLayout />}
                  >
                    <Route
                      path="/exercise/:idExercise/Content"
                      element={<Exercise />}
                    />
                  </Route>
                  <Route path="/workout/:idPlan" element={<PlanLayout />}>
                    <Route path="/workout/:idPlan/Content" element={<Plan />} />
                    <Route
                      path="/workout/:idPlan/Details"
                      element={<PlanDetails />}
                    />
                  </Route>
                  <Route
                    path="/workout/:idPlanDay/:idWorkout/:idSuperserie/:idExercise"
                    element={<WorkoutLayout />}
                  >
                    <Route
                      path="/workout/:idPlanDay/:idWorkout/:idSuperserie/:idExercise/Content"
                      element={<Workout />}
                    />
                    <Route
                      path="/workout/:idPlanDay/:idWorkout/:idSuperserie/:idExercise/Completed"
                      element={<WorkoutCompleted />}
                    />
                    <Route
                      path="/workout/:idPlanDay/:idWorkout/:idSuperserie/:idExercise/Details"
                      element={<WorkoutDetails />}
                    />
                    <Route
                      path="/workout/:idPlanDay/:idWorkout/:idSuperserie/:idExercise/ExerciseDetails"
                      element={<WorkoutExerciseDetails />}
                    />
                  </Route>
                  <Route path="/settings/" element={<Settings />} />
                  <Route path="/subscriptions/" element={<Subscriptions />} />
                  <Route path="/shop/" element={<ShopLayout />}>
                    <Route path="/shop/load/" element={<CheckoutSuccess />} />
                    <Route
                      path="/shop/success/"
                      element={<PurchaseSuccess />}
                    />
                    <Route path="/shop/fail/" element={<PurchaseFail />} />
                  </Route>
                  <Route path="private/" element={<AdminLayout />}>
                    <Route
                      path="/private/adminProtocols"
                      element={<AdminWorkouts />}
                    />
                    <Route
                      path="/private/adminWorkouts"
                      element={<AdminPlans />}
                    />
                    <Route
                      path="/private/adminExercises"
                      element={<AdminExercises />}
                    />
                    <Route
                      path="/private/adminUsers"
                      element={<AdminUsers />}
                    />
                    <Route
                      path="/private/adminSubscriptions"
                      element={<AdminSubscriptions />}
                    />
                  </Route>
                </Routes>
              </ExerciseProvider>
            </PlanProvider>
          </WorkoutProvider>
        </AuthProvider>
      </div>
    </Router>
  );
}

export default App;
